import type {
  InspectionCapabilities,
  InspectionDetail,
} from "../api/inspection";
import type { InspectionFormMode } from "../catalog/inspection-form-bundle";
import { isInspectionEditableStatus } from "./inspectionLabels";

/**
 * Ficha em somente leitura (form §4.1): status não editável, papel sem
 * `create` ou abertura explícita em modo visualização. Regra do módulo — vale
 * para qualquer `templateVersion`, por isso mora fora do bundle da versão.
 */
export const isInspectionFormReadOnly = (
  mode: InspectionFormMode,
  capabilities: InspectionCapabilities,
  detail: InspectionDetail | null,
): boolean =>
  !detail ||
  mode === "view" ||
  !capabilities.create ||
  !isInspectionEditableStatus(detail.inspectionStatus);
